import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { TextBoxUsersMentions } from '../../CustomControls/TextBoxUsersMentions';
import { FormErrorMessage } from '../../Validations/FormValidationErrors';

const REASON_LOAD_ERROR = 0;
const REASON_OTHER = 1;

export const RemoveVisitModal = ({ onConfirm, onCancel }) => {
    const { t } = useTranslation();
    const [reasonType, setReasonType] = useState(REASON_LOAD_ERROR);
    const [reasonText, setReasonText] = useState('');
    const [errors, setErrors] = useState(null);

    const handleChange = (name, value) => {
        if (name === 'removeVisit.reasonText') {
            setReasonText(value);
            setErrors(null);
        }
    };

    const handleSubmit = () => {
        if (reasonType === REASON_OTHER && !reasonText?.trim()) {
            setErrors([{ key: 'protocolNotifications.visitTracking_removeVisit_reason_otherText_required' }]);
            return;
        }
        onConfirm({ reasonType, reasonText: reasonType === REASON_OTHER ? reasonText : null });
    };

    return (
        <Modal show onHide={onCancel} bsSize="large" backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{t('protocolNotifications.visitTracking_removeVisit_title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <strong>{t('protocolNotifications.visitTracking_removeVisit_motivo')}:</strong>
                <div>
                    <label style={{ display: 'block', cursor: 'pointer' }}>
                        <input
                            type="radio"
                            name="reasonType"
                            checked={reasonType === REASON_LOAD_ERROR}
                            onChange={() => { setReasonType(REASON_LOAD_ERROR); setErrors(null); }}
                            style={{ marginRight: '8px' }}
                        />
                        {t('protocolNotifications.visitTracking_removeVisit_reason_loadError')}
                    </label>
                    <label style={{ display: 'block', cursor: 'pointer', marginTop: '8px' }}>
                        <input
                            type="radio"
                            name="reasonType"
                            checked={reasonType === REASON_OTHER}
                            onChange={() => { setReasonType(REASON_OTHER); setErrors(null); }}
                            style={{ marginRight: '8px' }}
                        />
                        {t('protocolNotifications.visitTracking_removeVisit_reason_other')}
                    </label>
                    {reasonType === REASON_OTHER && (
                        <>
                            <br />
                            <TextBoxUsersMentions
                                name="removeVisit.reasonText"
                                placeholder={t('protocolNotifications.visitTracking_removeVisit_reason_otherText')}
                                value={reasonText}
                                onChange={handleChange}
                            />
                        </>
                    )}
                </div>
                {errors && errors.map(error => (
                    <FormErrorMessage key={error.key}>{t(error.key)}</FormErrorMessage>
                ))}
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle="info" onClick={onCancel}>{t('buttons.cancel')}</Button>
                <Button bsStyle="danger" onClick={handleSubmit}>{t('buttons.confirm')}</Button>
            </Modal.Footer>
        </Modal>
    );
};
